import React from 'react';
export type BeeConceptId = 'favo' | 'voo' | 'selo';
interface BeeSymbolConceptProps {
  concept: BeeConceptId;
  size?: number;
  /** Symbol colour — Honey Gold by default. */
  gold?: string;
  /** Colour used for cut lines (stripes) — the surface colour behind the symbol. */
  surface?: string;
}

/**
 * Proposed BEELYV bee symbols for client approval (Client Review — Revision 01).
 * Concepts only: the approved symbol in BrandMark stays in use until one is chosen.
 * Drawn on a 64-unit grid with strokes heavy enough to survive 16px.
 */
export function BeeSymbolConcept({
  concept,
  size = 64,
  gold = '#C89432',
  surface = '#102A2A'
}: BeeSymbolConceptProps) {
  return <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true" strokeLinecap="round" strokeLinejoin="round" data-id="element-562" data-mp="ht3ltql6f0kt">
      {concept === 'favo' && <>
          {/* Leaf wings over a honeycomb body */}
          <path d="M30 23 C 23 9, 9 10, 10 20 C 11 28, 23 29, 30 23 Z" stroke={gold} strokeWidth={3} data-id="element-563" data-mp="7x07lmd1vbhi" />
          <path d="M34 23 C 41 9, 55 10, 54 20 C 53 28, 41 29, 34 23 Z" stroke={gold} strokeWidth={3} data-id="element-564" data-mp="348okghzjqk12" />
          <circle cx={32} cy={19} r={3.6} fill={gold} data-id="element-565" data-mp="2ucd85rzyhu6m" />
          <path d="M32 25 L 42 31 L 42 44 L 32 50 L 22 44 L 22 31 Z" fill={gold} data-id="element-566" data-mp="2udodhw91v9zu" />
          <path d="M23.5 35.5 H 40.5" stroke={surface} strokeWidth={2.6} data-id="element-567" data-mp="2zchq7mgiiwyy" />
          <path d="M23.5 41 H 40.5" stroke={surface} strokeWidth={2.6} data-id="element-568" data-mp="3n1afx16jk8l4" />
          <path d="M32 50 V 55" stroke={gold} strokeWidth={3} data-id="element-569" data-mp="3mz6c0j8n79ku" />
        </>}

      {concept === 'voo' && <g transform="rotate(-18 32 36)" data-id="element-570" data-mp="3d2uu9dqa9rj0">
          {/* Bee in flight, profile — one organic wing, line construction */}
          <path d="M29 29 C 22 13, 35 6, 40 14 C 44 21, 38 27, 29 29 Z" fill={gold} fillOpacity={0.22} stroke={gold} strokeWidth={2.6} data-id="element-571" data-mp="3i14tq0j1jeaf" />
          <ellipse cx={34} cy={38} rx={15} ry={9.5} stroke={gold} strokeWidth={3} data-id="element-572" data-mp="26n0y6pwt1i39" />
          <path d="M30 29.5 Q 27 38 30 46.5" stroke={gold} strokeWidth={2.6} data-id="element-573" data-mp="d4juwsl3vttf" />
          <path d="M37 28.7 Q 34 38 37 47.3" stroke={gold} strokeWidth={2.6} data-id="element-574" data-mp="84yvkh20xjg6" />
          <circle cx={15.5} cy={38} r={4.6} fill={gold} data-id="element-575" data-mp="871vptww4sym" />
          <path d="M13 34 Q 9.5 28 13.5 24.5" stroke={gold} strokeWidth={2.2} data-id="element-576" data-mp="3d74m5eyhbpi" />
          <path d="M49 38 L 54 38" stroke={gold} strokeWidth={3} data-id="element-577" data-mp="3ul1tqebv5rt6" />
        </g>}

      {concept === 'selo' && <>
          {/* Top-view bee inside a thin honeycomb seal */}
          <path d="M32 4.5 L 55.8 18.25 L 55.8 45.75 L 32 59.5 L 8.2 45.75 L 8.2 18.25 Z" stroke={gold} strokeWidth={1.8} strokeOpacity={0.7} data-id="element-578" data-mp="3lk3knhmkiu3q" />
          <path d="M28.5 28 C 19 27, 14.5 19, 20 15.5 C 25 12.5, 29 20, 28.5 28 Z" stroke={gold} strokeWidth={2.6} data-id="element-579" data-mp="3bm7cmyoxgf9u" />
          <path d="M35.5 28 C 45 27, 49.5 19, 44 15.5 C 39 12.5, 35 20, 35.5 28 Z" stroke={gold} strokeWidth={2.6} data-id="element-580" data-mp="1etnl8228xydy" />
          <circle cx={32} cy={20.5} r={4} fill={gold} data-id="element-581" data-mp="19vm59q04af6p" />
          <rect x={26.5} y={25.5} width={11} height={23} rx={5.5} fill={gold} data-id="element-582" data-mp="1he3hw53aia3w" />
          <path d="M27 33.5 H 37" stroke={surface} strokeWidth={2.4} data-id="element-583" data-mp="1hbzfxsoybl69" />
          <path d="M27 39.5 H 37" stroke={surface} strokeWidth={2.4} data-id="element-584" data-mp="1mbc3ygrk6yaf" />
        </>}
    </svg>;
}